// externals
import { RSAA } from 'redux-api-middleware';

// libraries
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// types
import type { StateTree, TradeInIntelligenceCompletionServiceData } from '@makemydeal/dr-dash-types';

// selectors
import { getDealXgId } from '../selectors/offerRedux';
import { getOfferGlobalCustomerId } from '../selectors/offerSelectors';

// consts/enums
import {
    TRADE_IN_INTELLIGENCE_EVENT_RECEIVED,
    TRADE_IN_INTELLIGENCE_FETCH_FAILURE,
    TRADE_IN_INTELLIGENCE_FETCH_REQUEST,
    TRADE_IN_INTELLIGENCE_FETCH_SUCCESS,
    TRADE_IN_INTELLIGENCE_REQUESTED,
    TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED,
    TRADE_IN_INTELLIGENCE_SETTLED_EMPTY,
    TRADE_IN_INTELLIGENCE_SUBSCRIBED
} from '../actionTypes/tradeInIntelligenceActionTypes';

export type TradeInIntelligenceSubscribedAction = {
    type: typeof TRADE_IN_INTELLIGENCE_SUBSCRIBED;
};

export type TradeInIntelligenceRequestedAction = {
    type: typeof TRADE_IN_INTELLIGENCE_REQUESTED;
    payload: { requestedAtMs: number };
};

export type TradeInIntelligenceRequestAcceptedAction = {
    type: typeof TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED;
    payload: { correlationId: string | null };
};

export type TradeInIntelligenceEventReceivedAction = {
    type: typeof TRADE_IN_INTELLIGENCE_EVENT_RECEIVED;
    payload: TradeInIntelligenceCompletionServiceData;
};

export type TradeInIntelligenceSettledEmptyAction = {
    type: typeof TRADE_IN_INTELLIGENCE_SETTLED_EMPTY;
};

export type TradeInIntelligenceActions =
    | TradeInIntelligenceSubscribedAction
    | TradeInIntelligenceRequestedAction
    | TradeInIntelligenceRequestAcceptedAction
    | TradeInIntelligenceEventReceivedAction
    | TradeInIntelligenceSettledEmptyAction;

export const requestTradeInIntelligence = (state: StateTree): RSAACallAction => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '');
    const gcid = encodeURIComponent(getOfferGlobalCustomerId(state));
    const query = new URLSearchParams({ dealId: getDealXgId(state) });

    const request: RSAACallRequest = {
        endpoint: `${bffApiUrlResult.url}/v3/deal-pulse/customers/${gcid}/trade-in-intelligence?${query.toString()}`,
        method: 'GET',
        types: [TRADE_IN_INTELLIGENCE_FETCH_REQUEST, TRADE_IN_INTELLIGENCE_FETCH_SUCCESS, TRADE_IN_INTELLIGENCE_FETCH_FAILURE]
    };

    return { [RSAA]: request };
};

export const tradeInIntelligenceSubscribed = (): TradeInIntelligenceSubscribedAction => ({
    type: TRADE_IN_INTELLIGENCE_SUBSCRIBED
});

export const tradeInIntelligenceRequested = (requestedAtMs: number): TradeInIntelligenceRequestedAction => ({
    type: TRADE_IN_INTELLIGENCE_REQUESTED,
    payload: { requestedAtMs }
});

export const tradeInIntelligenceRequestAccepted = (correlationId: string | null): TradeInIntelligenceRequestAcceptedAction => ({
    type: TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED,
    payload: { correlationId }
});

export const tradeInIntelligenceEventReceived = (
    completion: TradeInIntelligenceCompletionServiceData
): TradeInIntelligenceEventReceivedAction => ({
    type: TRADE_IN_INTELLIGENCE_EVENT_RECEIVED,
    payload: completion
});

export const tradeInIntelligenceSettledEmpty = (): TradeInIntelligenceSettledEmptyAction => ({
    type: TRADE_IN_INTELLIGENCE_SETTLED_EMPTY
});
